import React, { useEffect, useRef, useState } from "react";
import Button from "../components/Button";
import { ReactComponent as DoneSvg } from "../assets/svg/done.svg";
import { ReactComponent as ArrowSvg } from "../assets/svg/arrow_down.svg";
import { observer } from "mobx-react-lite";
import Dropdown from "../components/Dropdown";
import {
  notificationTimeouts,
  notificationTypes,
  paymentSystems,
  paymentSystemsHtml,
  paymentSystemsImages,
  paymentSystemsNames,
  paymentTypes,
  paymentTypesImages,
  paymentTypesNames,
  valutes,
} from "../utils/consts";
import userStore from "../store/userStore";
import { showStandartNotification } from "../utils/helpers";
import "../css/add-balance.css";
import { useLocation } from "react-router-dom";
import { paths } from "../paths";
import { LazyLoadImage } from "react-lazy-load-image-component";

const AddBalance = (props) => {
  const [addBalanceSum, setAddBalanceSum] = useState("");
  const [choosedPaymentType, setChoosedPaymentType] = useState(
    paymentTypesNames.cloudPayments
  );
  const location = useLocation();
  const balanceInputRef = useRef(null);

  // скролл к компоненту если есть параметр ?balance-input=
  useEffect(() => {
    const balanceInputTop =
      balanceInputRef?.current?.getBoundingClientRect().top;

    if (
      location.search.includes("balance-input") &&
      balanceInputTop !== undefined
    ) {
      window.scrollTo({
        top: balanceInputTop + window.scrollY, // Корректируем относительно текущей прокрутки
        behavior: "smooth", // Добавляем плавность прокрутки
      });
      balanceInputRef.current.focus();
    }
  }, [location.search, balanceInputRef]);

  async function handlePayment() {
    if (!addBalanceSum || isNaN(addBalanceSum) || addBalanceSum <= 0) {
      return showStandartNotification({
        text: "Введите корректную сумму",
        timeout: notificationTimeouts.short,
        type: notificationTypes.reject,
      });
    }

    if (addBalanceSum < 100) {
      return showStandartNotification({
        text: "Сумма должна быть не менее 100 руб.",
        timeout: notificationTimeouts.short,
        type: notificationTypes.reject,
      });
    }

    if (!userStore.isAuth) {
      return showStandartNotification({
        text: "Войдите в аккаунт",
        timeout: notificationTimeouts.short,
        type: notificationTypes.reject,
      });
    }

    console.log(window.cp);

    if (!window.cp) {
      return console.log("cp is not defined");
    }

    try {
      let language = "ru-RU";

      const widget = new window.cp.CloudPayments({
        language: language,
      });
      widget.pay(
        "auth", // или 'charge'
        {
          //options
          publicId: "pk_e1537f931f3d8ab0f7bc11128564a", //id из личного кабинета
          description: "Пополнение баланса на MEGALODON", //назначение
          amount: addBalanceSum, //сумма
          currency: "RUB", //валюта
          // accountId: 'user@example.com', //идентификатор плательщика (необязательно)
          // invoiceId: '1234567', //номер заказа  (необязательно)
          skin: "modern", //дизайн виджета (необязательно)
          // autoClose: 3,
          data: {
            steamId: userStore.data.steamId,
          },
          // configuration: {
          //   common: {
          //     successRedirectUrl: paths.Home, // адреса для перенаправления
          //     failRedirectUrl: paths.Home, // при оплате по T-Pay
          //   },
          // },
          // payer: {
          //   firstName: "Тест",
          //   lastName: "Тестов",
          //   middleName: "Тестович",
          //   birth: "1955-02-24",
          //   address: "тестовый проезд дом тест",
          //   street: "Lenina",
          //   city: "MO",
          //   country: "RU",
          //   phone: "123",
          //   postcode: "345",
          // },
        },
        {
          onSuccess: function (options) {
            // success
            //действие при успешной оплате
            console.log("onSuccess: ", options);
            userStore.addUserValutes({
              [userStore.userValutes.teeth]: addBalanceSum,
            });
          },
          onFail: function (reason, options) {
            // fail
            //действие при неуспешной оплате
            console.error("fail: ", reason, options);
          },
          onComplete: function (paymentResult, options) {
            //Вызывается как только виджет получает от api.cloudpayments ответ с результатом транзакции.
            //например вызов вашей аналитики Facebook Pixel
            console.log("onComplete: ", paymentResult, options);
          },
        }
      );
    } catch (err) {
      console.error(err);
    }

    // showStandartNotification({
    //   text: "Пополнение через сайт пока не доступно",
    //   timeout: notificationTimeouts.short,
    //   type: notificationTypes.reject,
    // });

    try {
      // const response = await fetch("/api/create-payment", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({ amount: addBalanceSum }),
      // });

      // const data = await response.json();

      // if (data.success && data.paymentUrl) {
      //   window.location.href = data.paymentUrl; // Перенаправление на страницу оплаты
      // } else {
      //   showStandartNotification({
      //     text: "Ошибка при создании платежа",
      //     timeout: notificationTimeouts.short,
      //     type: notificationTypes.error,
      //   });
      // }
      console.log("В разработке");
      // userStore.addUserValutes({ [valutes.teeth]: +addBalanceSum });
      // showStandartNotification({
      //   text: "Успешно",
      //   timeout: notificationTimeouts.short,
      //   type: notificationTypes.done,
      // });
    } catch (err) {
      showStandartNotification({
        text: "Ошибка",
        timeout: notificationTimeouts.short,
        type: notificationTypes.reject,
      });
      console.log(err);
    }
  }

  return (
    <div className="balance-container">
      <div className="payment-type">
        <span className="choosed-payment-type float-right">
          Выбрано: {paymentTypesImages[choosedPaymentType]} {choosedPaymentType}
        </span>
        <Dropdown
          noArrow={true}
          value={
            <Button className="choose-button gradient-background extra no-border spiked gap-0-25">
              выберите способ пополнения <ArrowSvg className="arrow" />
            </Button>
          }
          up={props.up ? true : false}
          animated={true}
        >
          {Object.values(paymentTypesNames).map((name) => (
            <button key={name} onClick={() => setChoosedPaymentType(name)}>
              {paymentTypesImages[name]} {name}
            </button>
          ))}
        </Dropdown>
      </div>
      <div className="sum">
        <input
          ref={balanceInputRef}
          type="number"
          id="changer-input"
          className="text-center"
          placeholder="сумма"
          min={0}
          value={addBalanceSum}
          onChange={(e) => setAddBalanceSum(parseInt(e.target.value))}
        />
        <Button className="no-border spiked gap-0-25" onClick={handlePayment}>
          <DoneSvg /> ПОПОЛНИТЬ
        </Button>
      </div>
    </div>
  );
};

export default observer(AddBalance);
